import { createApp } from 'vue'
import CalculatorSummary from './CalculatorSummary'
import handleComponentProps from '../../../../../../../Frontend/src/foundation/js/utils/handleComponentProps.js'

const el = '.nyk-component--calculator-summary'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((CalculatorSummaryDOM) => {
            const props = handleComponentProps(CalculatorSummary, CalculatorSummaryDOM)
            const component = createApp(CalculatorSummary, props).use(Store)
            component.mount(CalculatorSummaryDOM)
        })
    }
}
